module.exports = __webpack_public_path__ + "img/dollar.e0b48362.svg";